import React from 'react';
import WorkshopIndex from '../../workshop';

export default function () {
  return <WorkshopIndex noFixedVideo noExitIntent variant="ad" />;
}
